import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/app/App";
import "./custom.css";
import "./assests/styles/comun.scss";
import "./assests/styles/main.scss";
import "./assests/styles/buttons.scss";
import "primeicons/primeicons.css";
import "./assests/styles/dataTable.scss";

import * as serviceWorker from "./registerServiceWorker";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
